export default __webpack_public_path__ + "static/media/unicorn-like.31ec23a8.mp3";